import HTML from '@client/core/utils/HTML';
import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import { TextStyle } from '@client/style/TextStyles';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div<{ $bg: string; $fg: string }>`
	background-color: ${props => props.$bg};
	color: ${props => props.$fg};
	width: 100%;

	padding-top: 40px;
	padding-bottom: 40px;
	padding: 40px var(--gridMargin);

	${Functions.breakpoint(Breakpoints.mobile)} {
		padding: 0px ${Functions.col(4)};
		padding-bottom: 40px;

		padding-top: 80px;
	}

	&:has(+ .BreakerModule) {
		border-bottom: var(--breaker-total) solid transparent;
	}
`;

const TextWrapper = styled.div`
	width: 100%;
	text-align: center;
	margin: 10px 0;
	${TextStyle.size('p2', 'h4')}

	p {
		${TextStyle.family('title')}
		${TextStyle.weight('regular')}
		${TextStyle.size('large')}
		line-height: 1.3em;
		margin: 40px 0;

		${Functions.breakpoint(Breakpoints.mobile)} {
			${TextStyle.size('p6')}
			line-height: 1.2em;
		}
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin: 10px 0;
		${TextStyle.family('title')}
		${TextStyle.weight('bold')}
	}

	h1 {
		${TextStyle.size('h6', 'h2')}
		line-height: 1em;

		${Functions.breakpoint(Breakpoints.mobile)} {
			margin: 0;
		}
	}

	h2 {
		${TextStyle.size('p2', 'h4')}
		line-height: 1.1em;

		${Functions.breakpoint(Breakpoints.mobile)} {
			line-height: 1.2em;
			margin: 0;
		}
	}

	h6 {
		${TextStyle.weight('regular')}
		${TextStyle.size('p6', 'p2')}
		line-height: 1.2em;

		b {
			${TextStyle.weight('bold')}

			${Functions.breakpoint(Breakpoints.mobile)} {
				${TextStyle.size('p3')}
				line-height: 1em;
			}
		}
	}

	h6 + h2 {
		margin-top: 40px;
	}

	h1 + h6 {
		margin-top: 20px;
	}

	*:last-child {
		margin-bottom: 0;
	}
`;

export default function ListingTextModule({ data }: { data: { backgroundColor: any; text: string } }) {
	return (
		<Container
			className='colorWrapperAnimatedModule'
			$bg={data.backgroundColor?.color}
			$fg={data.backgroundColor?.contrastColor}
		>
			<TextWrapper dangerouslySetInnerHTML={{ __html: HTML.clean(data.text) }}></TextWrapper>
		</Container>
	);
}
